export const G = {
  white: "#FFFFFF",
  offWhite: "#F9FAFB",
  gray50: "#F9FAFB",
  gray100: "#F3F4F6",
  gray200: "#E5E7EB",
  gray300: "#D1D5DB",
  gray400: "#9CA3AF",
  gray500: "#6B7280",
  gray600: "#4B5563",
  gray700: "#374151",
  gray800: "#1F2937",
  gray900: "#111827",
  dark: "#071A2F",
  darkSlate: "#0B223F",
  darkBorder: "#1A3557",
  darkMuted: "#5B7A99",
  darkSubtle: "#1E4070",
  green50: "#F0FDF4",
  green100: "#DCFCE7",
  green500: "#22C55E",
  green600: "#16A34A",
  green700: "#15803D",
  amber50: "#FFFBEB",
  amber100: "#FEF3C7",
  amber600: "#D97706",
  amber700: "#B45309",
  red50: "#FEF2F2",
  red100: "#FEE2E2",
  red600: "#DC2626",
  red700: "#B91C1C",
  blue50: "#EFF6FF",
  blue100: "#DBEAFE",
  blue600: "#2563EB",
  blue700: "#1D4ED8",
  border: "#E5E7EB",
  accent: "#2563EB",
  // Brand — enterprise blue (structural UI chrome, not data-semantic)
  brand: "#2563EB",
  brandHover: "#1D4ED8",
  brandSubtle: "#EEF4FF",
  brandBorder: "#BFDBFE",
};

export const SPACING = {
  navH: 56,
  maxWidth: 1320,
  section: "96px 48px",
  cardPad: "28px",
  gap: 16,
  gapLg: 24,
  rowH: 52,
};

export const TYPE = {
  display: { fontSize: 52, fontWeight: 700, lineHeight: 1.05, letterSpacing: "-0.02em" },
  sectionTitle: { fontSize: 32, fontWeight: 700, lineHeight: 1.2, letterSpacing: "-0.01em" },
  featureTitle: { fontSize: 20, fontWeight: 600, lineHeight: 1.3, letterSpacing: "-0.005em" },
  overline: { fontSize: 11, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase" },
  body: { fontSize: 14, fontWeight: 400, lineHeight: 1.6 },
  small: { fontSize: 13, fontWeight: 400, lineHeight: 1.5 },
  caption: { fontSize: 12, fontWeight: 400, lineHeight: 1.4 },
  mono: { fontFamily: "'JetBrains Mono', 'Fira Code', monospace", fontSize: 13, fontWeight: 500 },
};

export const FONT_FAMILY = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

// ─────────────────────────────────────────────────────────────────────────────
// OVERVIEW — one grid, one spacing rhythm and one type scale for the whole
// Overview/Dashboard page. Additive only: nothing above changes, so Lifecycle
// and Workload are unaffected. Every Overview section is rendered through
// <OverviewSection> (horizontal grid + vertical rhythm) and <SectionHeader>
// (eyebrow → title → description), so alignment and hierarchy stay identical
// from the hero down to the Sprint Execution section.
// ─────────────────────────────────────────────────────────────────────────────
export const OVERVIEW = {
  // Horizontal grid — shared by TopNav, every section, every contained card.
  // contentMax is intentionally wide: on a standard desktop (with the sidebar)
  // it never binds, so the page reads as near-full-width with fixed gutters;
  // it only caps the line length on ultra-wide displays.
  contentMax: 1880,
  gutter: 48,

  // Vertical rhythm.
  sectionPadY: 72,        // top / bottom of a standard section band
  gapEyebrowTitle: 10,
  gapTitleDesc: 10,
  gapHeaderBody: 28,
  gapSectionInner: 24,

  // Containers — two deliberate tiers of the same family.
  cardRadius: 8,          // section-level container card
  panelRadius: 6,         // nested panel / metric tile
  cardBorder: "#BFDBFE",  // = G.brandBorder
  panelBorder: "#E5E7EB", // = G.border
  cardShadow: "0 1px 3px rgba(7,26,47,0.08), 0 12px 32px rgba(7,26,47,0.12)",

  // Type scale — small, deliberate set. Hierarchy comes from weight + spacing,
  // not from many sizes.
  eyebrow: { fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase" },
  title:   { fontSize: 28, fontWeight: 700, lineHeight: 1.2, letterSpacing: "-0.01em" },
  support: { fontSize: 14, fontWeight: 400, lineHeight: 1.6 },
};
